<template>
  <div>
    <div class="search-form">
      <el-form
        inline
        :model="originData"
        :rules="rules"
        ref="searchForm"
      >
        <el-form-item label="机构名称">
          <yh-select-tree
            clearable
            :load="loadChildOrgn"
            :value="originData.orgnName"
            @change="handleTreeChange"
            :render-content="renderTreeItem"
            accordion
            lazy
            :placeholder="treeSelectText"
          />
        </el-form-item>
        <el-form-item label="人员角色">
          <el-select
            clearable
            v-model="originData.roleId"
            placeholder="请选择角色"
          >
            <el-option
              v-for="item in roleDroplist"
              :key="item.id"
              :label="item.roleName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="人员工号"
          prop="workNo"
        >
          <el-input v-model.trim="originData.workNo"></el-input>
        </el-form-item>
        <el-form-item
          label="人员姓名"
          prop="userName"
        >
          <el-input v-model.trim="originData.userName"></el-input>
        </el-form-item>
        <el-form-item
          label="登录日期"
          style="margin-right: 12px"
        >
          <el-date-picker
            clearable
            :picker-options="startPickerOptions"
            v-model="originData.startTime"
            type="date"
            placeholder="请选择开始日期"
            format="yyyy-MM-dd"
          />
        </el-form-item>
        <el-form-item label="至">
          <el-date-picker
            clearable
            :picker-options="pickerOptions"
            v-model="originData.endTime"
            type="date"
            placeholder="请选择结束日期"
            format="yyyy-MM-dd"
          />
        </el-form-item>
      </el-form>
    </div>
    <div class="flex-between">
      <div>
        <el-button
          size="small"
          type="primary"
          @click="query"
        >查询</el-button>
        <el-button
          size="small"
          @click="reset"
        >清空查询条件</el-button>
      </div>
    </div>
    <div class="loginlog_table">
      <el-table
        :data="tableData"
        border
      >
        <template slot="empty">
          {{emptyText}}
        </template>
        <el-table-column
          prop="workNo"
          label="人员工号"
          min-width="130"
        >
        </el-table-column>
        <el-table-column label="人员姓名">
          <template slot-scope="scope">
            {{scope.row.userName | blankValue}}
          </template>
        </el-table-column>
        <el-table-column
          prop="roleName"
          label="人员角色"
          min-width="130"
        >
          <template slot-scope="scope">
            {{scope.row.roleName | blankValue}}
          </template>
        </el-table-column>
        <el-table-column
          prop="orgnCode"
          label="机构代码"
        >
          <template slot-scope="scope">
            {{scope.row.orgnCode | blankValue}}
          </template>
        </el-table-column>
        <el-table-column
          prop="orgnName"
          label="机构名称"
        >
          <template slot-scope="scope">
            {{scope.row.orgnName | blankValue}}
          </template>
        </el-table-column>
        <el-table-column
          label="设备ID"
          min-width="180"
        >
          <template slot-scope="scope">
            {{scope.row.logDeviceId | blankValue}}
          </template>
        </el-table-column>
        <el-table-column
          prop="loginIp"
          min-width="130"
          label="IP"
        >
        </el-table-column>
        <el-table-column
          label="登录时间"
          min-width="180"
        >
          <template slot-scope="scope">
            {{scope.row.loginDate | formatTime}}
          </template>
        </el-table-column>
        <el-table-column label="登录状态">
          <template slot-scope="scope">
            {{formatStatus(scope.row.loginStatus) | blankValue}}
          </template>
        </el-table-column>
      </el-table>
    </div>
    <yh-pagination
      :page.sync="currentPage"
      :total="sumCount"
    />
  </div>
</template>
<script>
import { getPagingData } from '@/mixins';

export default {
  name: 'PersonLogin',
  mixins: [getPagingData],
  data() {
    const validateNo = (rule, value, cb) => {
      if (value.length > 50) {
        cb(this.$MSG.M0001);
      } else {
        cb();
      }
    };
    const validateName = (rule, value, cb) => {
      if (value.length > 50) {
        cb(this.$MSG.M0002);
      } else {
        cb();
      }
    };
    return {
      rules: {
        workNo: [{
          validator: validateNo,
        }],
        userName: [{
          validator: validateName,
        }],
      },
      emptyText: this.$LS.empty,
      orgnName: '',
      orgnCode: '',
      // 初始数据
      originData: {
        orgnName: '',
        orgnCode: '',
        roleId: '',
        workNo: '',
        userName: '',
        startTime: '',
        endTime: '',
      },
      // 查询数据
      searchParam: {
        orgnCode: '',
        roleId: '',
        workNo: '',
        userName: '',
        startTime: '',
        endTime: '',
      },
      treeprops: {
        label: 'name',
        children: 'zones',
        isLeaf: 'leaf',
      },
      tableData: [],
      roleName: '',
      sumCount: 0,
      currentPage: 1,
      pageSize: 10,
      roleDroplist: [],
      orgnTreeData: {},
      orgnTreeDialog: false,
      temp: '',
      treeSelectText: '请选择机构名称',
    };
  },
  computed: {
    startPickerOptions() {
      return {
        disabledDate: (time) => {
          const notAfter = this.originData.endTime;
          if (notAfter) {
            return time.getTime() > notAfter.getTime();
          }
          return false;
        },
      };
    },
    pickerOptions() {
      return {
        disabledDate: (time) => {
          const notBefore = this.originData.startTime;
          if (notBefore) {
            return time.getTime() < notBefore.getTime();
          }
          return false;
        },
      };
    },
  },
  watch: {
    currentPage: {
      immediate: true,
      handler() {
        this.getTableData();
      },
    },
  },
  mounted() {
    this.getRoleDroplist();
  },
  methods: {
    formatStatus(status) {
      return {
        1: '成功',
        2: '失败',
        3: '异常',
      }[status];
    },
    // 渲染 el-tree 字节点
    renderTreeItem(h, { data }) {
      const className = 'ellipsis';
      if (data.name?.length >= 6) {
        return <el-tooltip placement="right" content={data.name}>
        <span
          class={className} style="width: 80px;">{data.name}</span>
        </el-tooltip>;
      }
      return (
        <span>{data.name}</span>
      );
    },
    // 查询按钮
    query() {
      this.$refs.searchForm.validate((valid) => {
        if (valid) {
          this.searchParam = {
            ...this.originData,
            startTime: this.originData.startTime ? this.formatDate(this.originData.startTime) : '',
            endTime: this.originData.endTime ? this.formatDate(this.originData.endTime) : '',
          };
          if (this.currentPage === 1) {
            this.getTableData();
          } else {
            this.currentPage = 1;
          }
        }
      });
    },
    // 重置按钮
    reset() {
      Object.keys(this.originData).forEach((key) => {
        this.originData[key] = '';
        this.searchParam[key] = '';
      });
    },
    // 获取表格数据
    getTableData() {
      this.getPagingData(this.$API.personLoginQuery);
    },
    // 角色下拉选项数据
    getRoleDroplist() {
      const sessData = JSON.parse(sessionStorage.getItem('sessionData'));
      const { roleId } = sessData;
      const parames = {
        data: {
          id: roleId,
        },
      };
      return this.$_post(this.$API.roleListByLevel, parames)
        .then((res) => {
          this.roleDroplist = res.data.list;
        });
    },
    // 加载机构树
    loadChildOrgn(node, resolve) {
      // const sessionData = JSON.parse(sessionStorage.getItem('sessionData'));
      if (node.level === 0) {
        return this.$_post(this.$API.getHeadOrg)
          .then((res) => {
            resolve([{
              name: res.data.info?.orgnName,
              orgnCode: res.data.info?.orgnCode,
            }]);
          });
      }
      const parames = {
        data: {
          orgnCode: node.data.orgnCode,
        },
      };
      return this.$_post(this.$API.subOrganizationList, parames)
        .then((res) => {
          const result = res.data.info.children?.map(item => ({
            name: item.title,
            orgnCode: item.id,
          }));
          resolve(result || []);
        });
    },
    // 选择机构树中数据
    handleTreeChange(data) {
      this.orgn = data;
      this.originData.orgnName = this.orgn.name;
      this.originData.orgnCode = this.orgn.orgnCode;
    },
  },
};
</script>
